import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import editorDirective, { loaded, unload } from './synap-directive'
const { v4: uuidv4 } = require('uuid')

declare var DEXT5: any

@Component({
  name: 'synap-editor-wrapper',
  directives: {
    synap: editorDirective,
  },
})
export default class SynapEditorWrapper
  extends Vue
  implements editor.IEumEditor
{
  //
  // ────────────────────────────────────────────────── I ──────────
  //   :::::: P R O P S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────
  //

  /** 본문 문자열 */
  @Prop({ type: String, default: '' }) private value!: string
  @Prop({ type: String, default: 'editor' }) mode!: editor.EditorMode
  /** 에디터 초기화 기 기본 몬문 문자열 */
  @Prop({ type: String, default: '' }) initialValue!: string
  /** 에디터 비활성화 여부 */
  @Prop({ type: Boolean, default: false }) disabled!: boolean
  /** 에디터 초기화 옵션 */
  @Prop({ type: Object }) synapopts!: editor.synap.SynapEditorConfig

  //
  // ──────────────────────────────────────────────── I ──────────
  //   :::::: D A T A : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────
  //

  /** 고유 키 생성 : 화면에 여러개의 에디터가 존재할 경우 ID 값이 고유해야함 */
  editorId!: string
  /** 본문 문자열 */
  body: string = '<p>&nbsp;</p>'
  /** 문문 문자열을 주기적으로 가져오기 위한 타이머 */
  timer: any = null
  /** 컴포넌트 폐기 이후 본문을 가져오는 타이머가 동작하지 않도록하기 위함 */
  disposed: boolean = false
  editor!: any

  //
  // ──────────────────────────────────────────────────────── I ──────────
  //   :::::: C O M P U T E D : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────────────
  //

  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: W A T C H E S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //

  @Watch('value')
  onValueChanged(val: string) {
    console.log('onValueChanged', val)
    if (val === this.body) return // 최적화
    if (!this.loaded()) return // 에디터 초기화 전에는 initialValue로만 본문 설정 가능
    this.setBodyValue(val) // 에디터와 로컬 body 상태 설정
  }

  //
  // ──────────────────────────────────────────────────────────── I ──────────
  //   :::::: L I F E C Y C L E S : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────────────────
  //

  created() {
    // editor unique id
    const uuid = uuidv4() as any
    this.editorId = 'editor' + uuid.replaceAll('-', '')
    // 본문 변경사항을 감시하는 타이머 시작
    // Timer가 동작함에 따라 에디터가 깜빡이는 증상이 었어서 주석 처리함.
    // this.startTimer()
  }

  beforeDestroy() {
    this.disposed = true
    clearTimeout(this.timer)
  }

  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: M E T H O D S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //

  handleLoaded(editor: any) {
    console.log(this.handleLoaded.name, editor)
    this.editor = editor

    this.$emit('loaded');
    // const { initialValue, value } = this
    // if (!initialValue && value) {
    //   this.setBodyValue(this.value)
    // }
  }

  // ────────────────────────────────────────────────────────────────────────────────
  // Private Methods

  /** DEXT5 Editor 초기화된 상태 */
  loaded(): boolean {
    return loaded(this.editorId)
  }

  // private startTimer(): void {
  //   const _this = this
  //   this.timer = setTimeout(() => {
  //     const { loaded, body, getBodyValue, notifyChangeBody, startTimer, disposed, timer } = _this
  //     // 컴포넌트가 폐기된 경우 타이머 리소스 해제
  //     clearTimeout(timer)
  //     if (disposed) {
  //       return
  //     }
  //     if (loaded()) {
  //       // 본문의 변경사항이 있을 경우, 변경사항을 알림
  //       const curBody = getBodyValue()
  //       if (body.length !== curBody.length) {
  //         notifyChangeBody(curBody)
  //       }
  //     }
  //     // 타이머 다시 시작
  //     if (!disposed) {
  //       startTimer()
  //     }
  //   }, 1000)
  // }

  // private notifyChangeBody(body: string) {
  //   if (this.loaded()) {
  //     console.log('notifyChangeBody', this.loaded(), ',', this.body, ',', body)
  //     this.body = body
  //     this.$emit('input', body)
  //   }
  // }

  // ────────────────────────────────────────────────────────────────────────────────
  // Public Methods (To access from other components)

  /** 에디터 본문 컨텐츠를 가져옵니다. */
  public getBodyValue(): string {
    var html = ''
    if (!this.isEmpty()) {
      // 에디터가 비어있을 경우를 판단하여 없을경우에만 html을 가져온다.
      if (this.editor) {
        html = this.editor.getPublishingHtml()
      } else {
        console.log('getBodyValue', this.loaded());
      }
    }
    return html
  }

  /** 에디터의 고유 아이디를 가져옵니다. */
  public getEditorId(): string {
    return this.editorId
  }

  /** 컨텐츠를 에디터 본문으로 설정합니다. */
  public setBodyValue(value: string): void {
    console.log('setBodyValue', this.loaded(), value)
    this.$nextTick(() => {
      this.body = value
      if (this.loaded()) {
        this.editor.openHTML(value)
      }
    })
  }

  /** 본문이 비어있는 상태인지 검사합니다. */
  public isEmpty(): boolean {
    if (this.editor) {
      return this.editor.isEmpty()
    } else {
      return false;
    }
  }

  /** 에디터 본문을 빈 값으로 초기화합니다. */
  public clear(): void {
    this.setBodyValue('')
  }
}
